import useUpload from './useUpload';

export default useUpload;
